import { useCallback, useRef } from 'react';
import { Editor, Range } from 'slate';
import { Transforms } from 'slate';

type Handlers = {
  persistedSelection: Range | null;
  onFocus: () => void;
  onBlur: () => void;
};

export function usePersistentSelection(editor: Editor): Handlers {
  const editorRef = useRef<Editor>(editor);
  const persistedSelectionRef = useRef<Range>();

  const onFocus = useCallback(() => {
    if (editorRef.current.selection == null && persistedSelectionRef.current != null) {
      Transforms.setSelection(editor, persistedSelectionRef.current);
    }
  }, [editor]);

  const onBlur = useCallback(() => {
    if (editorRef.current.selection != null) {
      persistedSelectionRef.current = editorRef.current.selection || undefined;
    }
  }, []);

  return { onFocus, onBlur, persistedSelection: persistedSelectionRef.current || null };
}
